import { useEffect, useState } from 'react';

const NAV_ITEMS = [
  { label: '社交矩阵', href: '#matrix' },
  { label: '最新动态', href: '#feed' },
  { label: '大家都在聊', href: '#talk' },
  { label: '更新节奏', href: '#timeline' },
  { label: '常见问题', href: '#faq' },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        solid
          ? 'border-b border-background-200 bg-background-50/95 backdrop-blur-md'
          : 'border-b border-transparent bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:h-20 md:px-6">
        <h1 className="flex items-center">
          <a href="#top" className="flex items-center gap-3" aria-label="黑料官方首页">
            <span
              className={`flex h-9 w-9 items-center justify-center rounded-md transition-colors ${
                solid ? 'bg-primary-600 text-background-50' : 'bg-background-50 text-primary-700'
              }`}
            >
              <i className="ri-newspaper-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-lg font-bold tracking-wide transition-colors ${
                  solid ? 'text-foreground-950' : 'text-background-50'
                }`}
              >
                黑料官方
              </span>
              <span
                className={`mt-1 text-[10px] tracking-[0.32em] transition-colors ${
                  solid ? 'text-foreground-500' : 'text-background-100/80'
                }`}
              >
                全平台社交矩阵
              </span>
            </span>
          </a>
        </h1>

        <nav className="hidden items-center gap-8 md:flex" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`whitespace-nowrap text-sm transition-colors ${
                solid
                  ? 'text-foreground-700 hover:text-primary-600'
                  : 'text-background-100 hover:text-background-50'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#matrix"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            <i className="ri-add-line text-base"></i>
            关注官方
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md border transition-colors md:hidden ${
            solid
              ? 'border-background-300 text-foreground-800'
              : 'border-background-50/40 text-background-50'
          }`}
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-2-line text-xl'}></i>
        </button>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <nav className="flex flex-col" aria-label="移动端导航">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="border-b border-background-100 px-2 py-3 text-sm text-foreground-800 last:border-b-0"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#matrix"
            onClick={() => setMenuOpen(false)}
            className="mt-4 flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-4 py-3 text-sm font-medium text-background-50"
          >
            <i className="ri-add-line text-base"></i>
            关注官方
          </a>
        </div>
      ) : null}
    </header>
  );
}